import oven1 from 'assets/oven/oven_1.png';
import oven2 from 'assets/oven/oven_2.png';
import oven3 from 'assets/oven/oven_3.png';
import oven4 from 'assets/oven/oven_4.png';
import oven5 from 'assets/oven/oven_5.png';
import oven6 from 'assets/oven/oven_6.png';
import cookie1 from 'assets/cookie/cookie_1.png';
import cookie2 from 'assets/cookie/cookie_2.png';
import cookie3 from 'assets/cookie/cookie_3.png';
import cookie4 from 'assets/cookie/cookie_4.png';
import cookie5 from 'assets/cookie/cookie_5.png';
import cookie6 from 'assets/cookie/cookie_6.png';
import cookie7 from 'assets/cookie/cookie_7.png';
import cookie8 from 'assets/cookie/cookie_8.png';
import cookie9 from 'assets/cookie/cookie_9.png';
import dough1 from 'assets/cookie/cookie_dough_1.png';
import dough2 from 'assets/cookie/cookie_dough_2.png';
import dough3 from 'assets/cookie/cookie_dough_3.png';
import dough4 from 'assets/cookie/cookie_dough_4.png';
import dough5 from 'assets/cookie/cookie_dough_5.png';
import dough6 from 'assets/cookie/cookie_dough_6.png';
import dough7 from 'assets/cookie/cookie_dough_7.png';
import dough8 from 'assets/cookie/cookie_dough_8.png';
import dough9 from 'assets/cookie/cookie_dough_9.png';
import logOutIcon from 'assets/img/float_log_out.png';
import logInIcon from 'assets/img/float_log_in.png';
import mainIcon from 'assets/img/float_main.png';
import ovenListIcon from 'assets/img/float_oven_list.png';
import guideIcon from 'assets/img/float_guide.png';
import cookie from 'assets/img/float_cookie.svg';
import myOvenIcon from 'assets/img/float_my_oven.png';

export const ovens = {
  1: oven1,
  2: oven2,
  3: oven3,
  4: oven4,
  5: oven5,
  6: oven6,
};

export const cookies = {
  1: cookie1,
  2: cookie2,
  3: cookie3,
  4: cookie4,
  5: cookie5,
  6: cookie6,
  7: cookie7,
  8: cookie8,
  9: cookie9,
};

export const doughs = {
  1: dough1,
  2: dough2,
  3: dough3,
  4: dough4,
  5: dough5,
  6: dough6,
  7: dough7,
  8: dough8,
  9: dough9,
};

export const floatIcon = {
  logout: logOutIcon,
  login: logInIcon,
  main: mainIcon,
  ovenlist: ovenListIcon,
  myoven: myOvenIcon,
  guide: guideIcon,
  cookie: cookie,
};
